(() => {
  function initialize(root) {
    if (root.dataset.legalReady) return;
    root.dataset.legalReady = 'true';
    const content = root.querySelector('[data-legal-content]');
    const toc = root.querySelector('[data-legal-toc]');
    if (!content || !toc) return;
    const sections = Array.from(content.children).filter(node => /^ARTICLE\s+\d+\s*[-–—:]/i.test(node.textContent.trim()));
    sections.forEach((node, index) => {
      let heading = node;
      if (node.tagName === 'P') {
        heading = document.createElement('h2');
        heading.innerHTML = node.innerHTML;
        node.replaceWith(heading);
      }
      heading.id = heading.id || `LegalArticle-${index + 1}`;
      heading.classList.add('ph-legal__heading');
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      toc.append(item);
    });
    if (sections.length) {
      root.querySelector('.ph-legal__navigation').hidden = false;
      root.classList.add('ph-legal--with-contents');
      root.querySelector('.ph-legal__contents').open = !window.matchMedia('(max-width: 767px)').matches;
    }
  }
  const initializeAll = () => document.querySelectorAll('[data-legal-page]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
